import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { MenuCard, MenuHeader, MenuSection } from "../../MenuCard";

const ITEMS = [
  { type: "section", label: "Comprobantes" },
  { label: "Facturas", icon: "fas fa-file-invoice-dollar", color: "#10b981", bg: "#f0fdf4", href: "/ListadoFacturas", desc: "Facturas timbradas", perm: "facturasFiscal" },
  { label: "Complementos Pagos", icon: "fas fa-money-bill-wave", color: "#3b82f6", bg: "#eff6ff", href: "/ListadoComplementosPago", desc: "Complementos de pago", perm: "compPagosFiscal" },
  { label: "Notas de Credito", icon: "fas fa-money-check-alt", color: "#f59e0b", bg: "#fffbeb", href: "/ListadoNotasCredito", desc: "Notas de crédito", perm: "notasCreditoFiscal" },
  { label: "Devoluciones", icon: "fas fa-undo-alt", color: "#8b5cf6", bg: "#f5f3ff", href: "/ListadoDevolucionesFiscal", desc: "Devoluciones fiscales", perm: "devolucionesFiscal" },
  { type: "section", label: "Cobranza fiscal" },
  { label: "Abonos Facturas", icon: "fas fa-money-bill-wave", color: "#0ea5e9", bg: "#f0f9ff", href: "/ListadoAbonosFacturas", desc: "Abonos aplicados a facturas", perm: "compPagosFiscal" },
  { label: "Estado Cuenta", icon: "fas fa-file-invoice-dollar", color: "#f43f5e", bg: "#fff1f2", href: "/EstadoCuentaK", desc: "Estado de cuenta fiscal", perm: "menu_fiscal" },
  { type: "section", label: "Configuración" },
  { label: "Registrar FIEL", icon: "fas fa-file-alt", color: "#14b8a6", bg: "#f0fdfa", href: "/RegistrarEmpresas", desc: "Registro de FIEL y CSD", perm: "menu_fiscal" },
];

function BotonesFiscal() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <Header />
      <div className="card container">
        <MenuHeader icon="fas fa-file-invoice-dollar" color="#8b5cf6" bg="#f5f3ff" title="Fiscal" subtitle="Facturación electrónica y CFDI" />
        {user.menu_fiscal ? (
          <div className="row">
            {ITEMS.map((r, i) =>
              r.type === "section"
                ? <MenuSection key={i} title={r.label} />
                : <MenuCard key={i} {...r} enabled={!!user[r.perm]} />
            )}
          </div>
        ) : <p style={{ color: "#94a3b8", fontSize: "0.82rem" }}>Sin acceso.</p>}
      </div>
    </>
  );
}

export default BotonesFiscal;
